import "./PerformanceWidget.css";

function PieChart({ data, size }){
    const totalAmount = data.reduce((sum, item) => sum + item.value, 0);
    let totalPercent = 0;

    const getCoordinatesForPercent = (percent) => {
        const x = Math.cos(2 * Math.PI * percent);
        const y = Math.sin(2 * Math.PI * percent);

        return [x, y];
    };

    return(
        <section className="pie-chart-display" aria-label="Call outcome percentages">
            <svg viewBox="-1 -1 2 2" width={size} height={size} role="img" aria-label="Calls by outcome pie chart">
                {data.map((slice) => {
                    const beginningPercent = totalPercent;
                    const slicePercent = slice.value / totalAmount;
                    totalPercent += slicePercent;

                    const [startX, startY] = getCoordinatesForPercent(beginningPercent);
                    const [endX, endY] = getCoordinatesForPercent(totalPercent);
                    const arcSizecheck = slicePercent > 0.5 ? 1 : 0;
                    const pathData = `M 0 0 L ${startX} ${startY} A 1 1 0 ${arcSizecheck} 1 ${endX} ${endY} Z`;

                    return <path key={slice.label} d={pathData} fill={slice.color} />;
                })}
            </svg>
            <ul className="pie-chart-view">
                {data.map((item) => (
                    <li key={item.label}>
                        <span><span className="color-user" style={{ backgroundColor: item.color }} />{item.label}: {Math.round((item.value / totalAmount) * 100)}%</span>
                    </li>
                ))}
            </ul>
        </section>
    );
}

export default PieChart;